
import axios from 'axios'

export default {
    // 免额
    getMeDiscountList({commit}, params){
        return axios.post('/api/facepay/discount/me/list', params)
    },
    addMeDiscount({commit}, params){
        return axios.post('/api/facepay/discount/me/add', params)
    },
    modifyMeDiscount({commit}, params){
        return axios.post('/api/facepay/discount/me/modify', params)
    },
    deleteMeDiscount({commit}, params){
        return axios.post('/api/facepay/discount/me/delete', params)
    },
    // 折扣
    getZkDiscountList({commit}, params){
        return axios.post('/api/facepay/discount/dz/list', params)
    },
    addZkDiscount({commit}, params){
        return axios.post('/api/facepay/discount/dz/add', params)
    },
    modifyZkDiscount({commit}, params){
        return axios.post('/api/facepay/discount/dz/modify', params)
    },
    deleteZkDiscount({commit}, params){
        return axios.post('/api/facepay/discount/dz/delete', params)
    },
    // 定额
    getDeDiscountList({commit}, params){
        return axios.post('/api/facepay/discount/de/list', params)
    },
    addDeDiscount({commit}, params){
        return axios.post('/api/facepay/discount/de/add', params)
    },
    modifyDeDiscount({commit}, params){
        return axios.post('/api/facepay/discount/de/modify', params)
    },
    deleteDeDiscount({commit}, params){
        return axios.post('/api/facepay/discount/de/delete', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/discount.js